export const OFFICE_OPS_NAV_CHANGED = 'OFFICE_OPS_NAV_CHANGED';

export type OfficeOpsNavController = {
  goPrev: () => boolean;
  goNext: () => boolean;
  canGoPrev: () => boolean;
  canGoNext: () => boolean;
};

let controller: OfficeOpsNavController | null = null;
let lastCanGoPrev: boolean | null = null;
let lastCanGoNext: boolean | null = null;

export const registerOfficeOpsNav = (next: OfficeOpsNavController | null) => {
  controller = next;

  const canGoPrev = next?.canGoPrev() ?? false;
  const canGoNext = next?.canGoNext() ?? false;

  if (next === null) {
    lastCanGoPrev = null;
    lastCanGoNext = null;
    window.dispatchEvent(
      new CustomEvent(OFFICE_OPS_NAV_CHANGED, {
        detail: { canGoPrev: false, canGoNext: false }
      })
    );
    return;
  }

  if (canGoPrev === lastCanGoPrev && canGoNext === lastCanGoNext) return;

  lastCanGoPrev = canGoPrev;
  lastCanGoNext = canGoNext;

  window.dispatchEvent(
    new CustomEvent(OFFICE_OPS_NAV_CHANGED, {
      detail: { canGoPrev, canGoNext }
    })
  );
};

export const getOfficeOpsNav = () => controller;
